export type Athlete = {
    id: string;
    displayName: string;
    shortName: string;
    jersey?: number;
    position: Position;
    weight?: number;
    team: string;
}

export enum Position {
    SF = 'SF',
    C = 'C',
    PG = 'PG',
    SG = 'SG',
    F = 'F',
    PF = 'PF',
    G = 'G',
    NA = 'NA'
}

